import React, {FC} from 'react'
import {Text} from 'wix-ui-tpa/cssVars'
import {useCurrencyFormatter, useTranslation} from '@wix/yoshi-flow-editor'
import {PaymentPolicyType as PaymentPolicyTypeProto} from '@wix/ambassador-table-reservations-v1-experience/types'

interface Props {
  className?: string
  currency?: string | null
  paymentPolicy?: any
}

export const ExperiencePrice: FC<Props> = ({className, currency, paymentPolicy}) => {
  const {t} = useTranslation()
  const formatCurrency = useCurrencyFormatter()

  if (currency && paymentPolicy) {
    if (paymentPolicy?.paymentPolicyType === PaymentPolicyTypeProto.FREE) {
      return <Text className={className}>{t('uou-reservations.experiences.price-free')}</Text>
    }

    const pricePerGuest = paymentPolicy?.perGuestOptions?.price
    const formattedPricePerGuest = pricePerGuest
      ? formatCurrency({value: pricePerGuest, currency})
      : null

    if (
      paymentPolicy?.paymentPolicyType === PaymentPolicyTypeProto.PER_GUEST &&
      formattedPricePerGuest
    ) {
      return (
        <Text className={className}>
          {t('uou-reservations.experiences.price-per-guest', {
            price: formattedPricePerGuest,
          })}
        </Text>
      )
    }
  }

  return null
}
